/* tslint:disable */
export var icon = "\n<svg width=\"17\" height=\"17\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.5 17a8.5 8.5 0 110-17 8.5 8.5 0 010 17z\" fill=\"#EE5951\"/><path d=\"M4 9h9V8H4v1z\" fill=\"#fff\"/></svg>\n";
//# sourceMappingURL=delete-section-full.svg.js.map